import styled from 'styled-components';

const AccountHeaderContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
`;

export default AccountHeaderContainer;
